import { render, staticRenderFns } from "./Captchar.vue?vue&type=template&id=50c8884b&scoped=true"
import script from "./Captchar.vue?vue&type=script&lang=js"
export * from "./Captchar.vue?vue&type=script&lang=js"
import style0 from "./Captchar.vue?vue&type=style&index=0&id=50c8884b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c8884b",
  null
  
)

export default component.exports